import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Legend,
} from "chart.js";
import type { ChartData, ChartOptions } from "chart.js";

import "./BarGraph.styles.scss";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Legend);

const options: ChartOptions<"bar"> = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: { left: 14 },
  },
  plugins: {
    legend: {
      position: "left",
    },
    title: {
      display: true,
      text: "All Deals",
      color: "#173c4c",
      align: "start",
      font: {
        family: "Roboto",
        size: 16,
        weight: "500",
      },
    },
  },
  scales: {
    x: {
      display: true,
      grid: {
        tickLength: 10,
      },
    },
    y: {
      display: false,
    },
  },
};

export const BarGraph: React.FC<ChartData<"bar">> = ({ ...data }) => {
  return (
    <div className="bar-graph" style={{ height: 110 }}>
      <Bar data={data} options={options} />
    </div>
  );
};
